import Modal from './Modal'

import ModalHeader from './ModalHeader'
import ModalContent from './ModalContent'
import ModalBottom from './variants/ModalBottom'

export { Modal, ModalHeader, ModalContent, ModalBottom }

export default Modal
